var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconLockSimple = function SvgIconLockSimple(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-lock-simple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29395 13.2919V8.24614C3.29395 7.42621 3.61894 7.00994 4.30792 6.90902V5.38269C4.30792 2.9229 5.84188 1.3335 7.99983 1.3335C10.1578 1.3335 11.6917 2.9229 11.6917 5.38269V6.89641C12.3807 6.99732 12.7057 7.4136 12.7057 8.24614V13.2919C12.7057 14.2379 12.2767 14.6668 11.3797 14.6668H4.61991C3.72293 14.6668 3.29395 14.2379 3.29395 13.2919ZM5.66003 6.88377L10.3399 6.87115V5.24391C10.3399 3.6545 9.40394 2.60751 7.99997 2.60751C6.59601 2.60751 5.66003 3.6545 5.66003 5.24391V6.88377Z",
    fill: "#E5E4EC"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconLockSimple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-lock-simple.e157788885d065e2c7654416da7560f1.svg";